export class CheckedCheckBox{
    constructor(
     public Agenda: string,
     public VisitasDeEmpresa: string,
     public ReunionesConSME: string,
     public Revisiones: string,
    ){}
   }
 